import Vue from "vue";
import axios from "axios";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import i18n from "./i18n";
import "./plugins/base";
//custom functions
import GlobalFunction from "./helper/globalFunctions.js";
Vue.prototype.$subStringDate = GlobalFunction.subStringDate;
Vue.prototype.$copyToClipboard = GlobalFunction.copyToClipboard;
Vue.prototype.$convertSecondToTime = GlobalFunction.convertSecondToTime;
Vue.prototype.$distance = GlobalFunction.distance;


import VuetifyGoogleAutocomplete from "vuetify-google-autocomplete";
Vue.use(VuetifyGoogleAutocomplete, {
  /*
      not used as loaded with component */
  apiKey: process.env.VUE_APP_GOOGLEMAP_KEY,

  vueGoogleMapsCompatibility: true,
});

import * as VueGoogleMaps from "vue2-google-maps";

Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLEMAP_KEY,
    //
    // AIzaSyDKS91zqmFXyHfGk6BRaN74TWb8bgfeO3E
    libraries: ["places", "geometry"],
    language: i18n.locale,
    region: $cookies.get('code')
    // v: '3.26',
  },
});

import Toasted from "vue-toasted";
Vue.use(Toasted);

import VueCookies from "vue-cookies";
Vue.use(VueCookies);
// set default config
Vue.$cookies.config("7d");
// set global cookie
Vue.$cookies.set("vps", "R8");
Vue.$cookies.set("oid", "none");
Vue.$cookies.set("uuid", "none");
Vue.$cookies.set("copy", "2021");
Vue.$cookies.set("keeplog", "true");
Vue.$cookies.set("pex", "7eFc3gz");
Vue.$cookies.set("company", "pexcode");
Vue.$cookies.set("config", "7d");
Vue.$cookies.set("geo", "not yet");
Vue.$cookies.set("QS", "quick services");
Vue.$cookies.set("lat", "none");
Vue.$cookies.set("lng", "none");
Vue.$cookies.set("lang", i18n.locale);
Vue.$cookies.set("local", "false");
Vue.$cookies.set("BASE_URL", "/");

import VueSplash from "vue-splash";
Vue.use(VueSplash);
// you can also pass options, check options reference below
// Vue.use(Toasted, Options);

import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
// Components

Vue.config.productionTip = false; //run as production

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (store.state.users.token) {
      next();
    } else {
      next("/login");
    }
  } else {
    next();
  }
});
router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.isNotAuth)) {
    if (!store.state.users.token) {
      next();
    } else {
      if (store.state.users.userMe.role == 1 || store.state.users.userMe.role == 5)
        next("/app/analysis");
      else
        next("/app/packages");
    }
  } else {
    next();
  }
});

axios.defaults.baseURL = process.env.VUE_APP_Api;
axios.defaults.headers.app = "test auth application";
axios.defaults.headers.language = i18n.locale;
Vue.use(VueSweetalert2);
new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
